import React, { useMemo } from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import { IOption, IEnhancedAutocompleteProps } from './interfaces';

export const EnhancedAutocomplete = <T extends Record<string, any>>({
  data,
  keyProperty,
  showKeyProperty,
  valueProperty,
  value,
  label,
  onChange,
  variant,
  loading,
  disabled,
  error,
  helperText,
  className
}: IEnhancedAutocompleteProps<T>): React.JSX.Element => {
  const options: IOption[] = useMemo(
    () =>
      data.map((item: T) => ({
        key: String(item[keyProperty]),
        value: String(item[valueProperty])
      })),
    [data, keyProperty, valueProperty]
  );

  const handleValueChange = (event: React.SyntheticEvent<unknown>, newValue: IOption | null) => {
    onChange(newValue || null);
  };

  const getOptionLabel = (option: IOption): string => {
    if (!option || option.key === '' || option.value === '') {
      return '';
    }

    return showKeyProperty ? `${option.key} - ${option.value}` : option.value;
  };

  return (
    <Autocomplete
      className={className}
      options={options}
      getOptionLabel={getOptionLabel}
      getOptionSelected={(option, value) => option.value === value.value}
      value={value}
      onChange={handleValueChange}
      loading={loading}
      loadingText="Carregando..."
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          error={error}
          helperText={helperText}
          variant={variant || 'standard'}
          label={label}
          fullWidth
        />
      )}
    />
  );
};
